import * as React from 'react';
import Portal from '@mui/material/Portal';
import { AdContext } from './AdManager';
import { jsx as _jsx } from "react/jsx-runtime";
function AdGuest(props) {
  var _props$classSelector = props.classSelector,
    classSelector = _props$classSelector === void 0 ? '.description' : _props$classSelector,
    children = props.children;
  var ad = React.useContext(AdContext);
  if (!ad.element) {
    return null;
  }
  return /*#__PURE__*/_jsx(Portal, {
    container: function container() {
      var element = document.querySelector(classSelector);
      if (element) {
        if (ad.element === element) {
          element.classList.add('ad');
        } else {
          element.classList.remove('ad');
        }
      }
      return ad.element;
    },
    children: children
  });
}
export { AdGuest };